import './agencyAnimation.scss';

(function () {

    let height = 680;
    let width = 1280;

    let data = {
        "nodes": [
            {"id": 0,"name":"Data","group":0, "radius": 73.3, "x": 180.9, "y": 228.9, "icon":0},
            {"id": 1,"name":"People","group":1, "radius": 45.5, "x": 281.5, "y": 467.1, "icon":0},
            {"id": 2,"name":"Devices","group":2, "radius": 52, "x": 440.6, "y": 444, "icon":0},
            {"id": 3,"name":"Touchpoints","group":3, "radius": 62.2, "x": 733.9, "y": 372.1, "icon":0},
            {"id": 4,"name":"Company","group":4, "radius": 71.6, "x": 1044.5, "y": 382.5, "icon":0},
            {"id": 5,"name":"","group":2, "radius": 28.4, "x": 353.3, "y": 310.8, "icon":1},
            {"id": 6,"name":"","group":2, "radius": 23.4, "x": 544.3, "y": 317, "icon":2},
            {"id": 7,"name":"","group":2, "radius": 34.2, "x": 515.2, "y": 521.6, "icon":3},
            {"id": 8,"name":"","group":3, "radius": 20.8, "x": 650, "y": 233.1, "icon":4},
            {"id": 9,"name":"","group":3, "radius": 20, "x": 695, "y": 256, "icon":5},
            {"id": 10,"name":"","group":3, "radius": 27.6, "x": 824.5, "y": 235.6, "icon":6},
            {"id": 11,"name":"","group":3, "radius": 26.2, "x": 832.8, "y": 345.1, "icon":7},
            {"id": 12,"name":"","group":3, "radius": 30.6, "x": 814.2, "y": 432.7, "icon":8},
            {"id": 13,"name":"","group":4, "radius": 27, "x": 1108.3, "y": 209.5, "icon":9},
            {"id": 14,"name":"","group":4, "radius": 27, "x": 1163.6, "y": 318.5, "icon":10},
            {"id": 15,"name":"","group":4, "radius": 27, "x": 1059.4, "y": 508.4, "icon":11},
            {"id": 16,"name":"","group":4, "radius": 31, "x": 1179.3, "y": 436.6, "icon":12},
            {"id": 17,"name":"","group":0, "radius": 23.2, "x": 218.7, "y": 106.7, "icon":13},
            {"id": 18,"name":"","group":0, "radius": 28.1, "x": 129.6, "y": 82.4, "icon":14},
            {"id": 19,"name":"","group":0, "radius": 28.1, "x": 59.8, "y": 171, "icon":15},
            {"id": 20,"name":"","group":1, "radius": 23.5, "x": 221.5, "y": 559.5, "icon":16},
            {"id": 21,"name":"","group":1, "radius": 23.5, "x": 177.5, "y": 441.5, "icon":17},
            {"id": 22,"name":"","group":0, "radius": 9.9, "x": 270.1, "y": 110.5, "icon":0},
            {"id": 23,"name":"","group":0, "radius": 9.9, "x": 194.8, "y": 55.3, "icon":0},
            {"id": 24,"name":"","group":0, "radius": 9.9, "x": 69.7, "y": 229.5, "icon":0},
            {"id": 25,"name":"","group":0, "radius": 6.7, "x": 53.2, "y": 110.5, "icon":0},
            {"id": 26,"name":"","group":0, "radius": 6.7, "x": 153.3, "y": 30, "icon":0},
            {"id": 27,"name":"","group":0, "radius": 6.7, "x": 270.1, "y": 82.4, "icon":0},
            {"id": 28,"name":"","group":0, "radius": 3.1, "x": 327.5, "y": 68.9, "icon":0},
            {"id": 29,"name":"","group":0, "radius": 3.1, "x": 307.5, "y": 189.9, "icon":0},
            {"id": 30,"name":"","group":0, "radius": 3.1, "x": 388.5, "y": 68.9, "icon":0},
            {"id": 31,"name":"","group":0, "radius": 3.1, "x": 494.5, "y": 56.9, "icon":0},
            {"id": 32,"name":"","group":0, "radius": 1.5, "x": 288.5, "y": 49.9, "icon":0},
            {"id": 33,"name":"","group":0, "radius": 1.5, "x": 198.5, "y": 19.9, "icon":0},
            {"id": 34,"name":"","group":0, "radius": 1.5, "x": 88.5, "y": 9.9, "icon":0},
            {"id": 35,"name":"","group":0, "radius": 1.5, "x": 97.5, "y": 128.9, "icon":0},
            {"id": 36,"name":"","group":0, "radius": 1.5, "x": 26.5, "y": 128.9, "icon":0},
            {"id": 37,"name":"","group":0, "radius": 1.5, "x": 36.5, "y": 198.9, "icon":0},
            {"id": 38,"name":"","group":0, "radius": 3.1, "x": 254.5, "y": 28.9, "icon":0},
            {"id": 39,"name":"","group":0, "radius": 3.1, "x": 43.5, "y": 48.9, "icon":0},
            {"id": 40,"name":"","group":0, "radius": 3.1, "x": 41.5, "y": 299.9, "icon":0},
            {"id": 41,"name":"","group":0, "radius": 6.7, "x": 28.4, "y": 222.6, "icon":0},
            {"id": 42,"name":"","group":0, "radius": 5.5, "x": 176, "y": 91.7, "icon":0},
            {"id": 43,"name":"","group":1, "radius": 11.2, "x": 143.3, "y": 415.2, "icon":0},
            {"id": 44,"name":"","group":1, "radius": 11.2, "x": 308.3, "y": 595, "icon":0},
            {"id": 45,"name":"","group":1, "radius": 11.2, "x": 179, "y": 550.2, "icon":0},
            {"id": 46,"name":"","group":1, "radius": 6.7, "x": 124.5, "y": 462.5, "icon":0},
            {"id": 47,"name":"","group":1, "radius": 6.7, "x": 332.9, "y": 554.9, "icon":0},
            {"id": 48,"name":"","group":1, "radius": 2.7, "x": 284.7, "y": 542.5, "icon":0},
            {"id": 49,"name":"","group":1, "radius": 2.7, "x": 134.7, "y": 499.5, "icon":0},
            {"id": 50,"name":"","group":1, "radius": 2.7, "x": 98.7, "y": 562.5, "icon":0},
            {"id": 51,"name":"","group":1, "radius": 2.7, "x": 74.7, "y": 408.5, "icon":0},
            {"id": 52,"name":"","group":1, "radius": 2.7, "x": 364.7, "y": 569.5, "icon":0},
            {"id": 53,"name":"","group":1, "radius": 1.5, "x": 97.7, "y": 458.5, "icon":0},
            {"id": 54,"name":"","group":1, "radius": 1.5, "x": 155.7, "y": 539.5, "icon":0},
            {"id": 55,"name":"","group":1, "radius": 1.5, "x": 216.7, "y": 509.5, "icon":0},
            {"id": 56,"name":"","group":1, "radius": 1.5, "x": 205.7, "y": 462.5, "icon":0},
            {"id": 57,"name":"","group":1, "radius": 1.5, "x": 188.7, "y": 579.5, "icon":0},
            {"id": 58,"name":"","group":1, "radius": 1.5, "x": 279.7, "y": 590.5, "icon":0},
            {"id": 59,"name":"","group":1, "radius": 1.5, "x": 330.7, "y": 510.5, "icon":0},
            {"id": 60,"name":"","group":1, "radius": 1.5, "x": 270.7, "y": 411.5, "icon":0},
            {"id": 61,"name":"","group":1, "radius": 1.5, "x": 109.7, "y": 371.5, "icon":0},
            {"id": 62,"name":"","group":1, "radius": 2.7, "x": 291.1, "y": 374.9, "icon":0},
            {"id": 63,"name":"","group":2, "radius": 10, "x": 601, "y": 410.5, "icon":0},
            {"id": 64,"name":"","group":2, "radius": 10, "x": 556, "y": 485.5, "icon":0},
            {"id": 65,"name":"","group":2, "radius": 10, "x": 352, "y": 409.5, "icon":0},
            {"id": 66,"name":"","group":2, "radius": 10, "x": 487, "y": 362.5, "icon":0},
            {"id": 67,"name":"","group":2, "radius": 10, "x": 396, "y": 272.5, "icon":0},
            {"id": 68,"name":"","group":2, "radius": 6.5, "x": 521.5, "y": 606, "icon":0},
            {"id": 69,"name":"","group":2, "radius": 6.5, "x": 514, "y": 285, "icon":0},
            {"id": 70,"name":"","group":2, "radius": 6.5, "x": 449.5, "y": 303, "icon":0},
            {"id": 71,"name":"","group":2, "radius": 6.5, "x": 393, "y": 310.5, "icon":0},
            {"id": 72,"name":"","group":2, "radius": 6.5, "x": 379.5, "y": 513, "icon":0},
            {"id": 73,"name":"","group":2, "radius": 2.4, "x": 491.8, "y": 328.3, "icon":0},
            {"id": 74,"name":"","group":2, "radius": 2.4, "x": 572.8, "y": 264.3, "icon":0},
            {"id": 75,"name":"","group":2, "radius": 2.4, "x": 358.8, "y": 368.3, "icon":0},
            {"id": 76,"name":"","group":2, "radius": 2.4, "x": 308.8, "y": 320.3, "icon":0},
            {"id": 77,"name":"","group":2, "radius": 1.5, "x": 381.8, "y": 233.3, "icon":0},
            {"id": 78,"name":"","group":2, "radius": 2.4, "x": 440.8, "y": 181.3, "icon":0},
            {"id": 79,"name":"","group":2, "radius": 1.5, "x": 511.8, "y": 396.3, "icon":0},
            {"id": 80,"name":"","group":2, "radius": 1.5, "x": 421.8, "y": 667.3, "icon":0},
            {"id": 81,"name":"","group":2, "radius": 1.5, "x": 378.8, "y": 478.3, "icon":0},
            {"id": 82,"name":"","group":2, "radius": 1.5, "x": 534.8, "y": 477.3, "icon":0},
            {"id": 83,"name":"","group":2, "radius": 1.5, "x": 554.8, "y": 588.3, "icon":0},
            {"id": 84,"name":"","group":2, "radius": 1.5, "x": 273.3, "y": 264.3, "icon":0},
            {"id": 85,"name":"","group":2, "radius": 1.5, "x": 440.8, "y": 339.3, "icon":0},
            {"id": 86,"name":"","group":2, "radius": 1.5, "x": 481.8, "y": 201.3, "icon":0},
            {"id": 87,"name":"","group":2, "radius": 2.4, "x": 513.8, "y": 579.3, "icon":0},
            {"id": 88,"name":"","group":2, "radius": 2.4, "x": 462.8, "y": 619.3, "icon":0},
            {"id": 89,"name":"","group":2, "radius": 2.4, "x": 623.8, "y": 579.3, "icon":0},
            {"id": 90,"name":"","group":2, "radius": 2.4, "x": 583.8, "y": 660.3, "icon":0},
            {"id": 91,"name":"","group":2, "radius": 2.4, "x": 563.8, "y": 510.3, "icon":0},
            {"id": 92,"name":"","group":2, "radius": 2.4, "x": 562.8, "y": 386.3, "icon":0},
            {"id": 93,"name":"","group":2, "radius": 2.4, "x": 608.8, "y": 369.3, "icon":0},
            {"id": 94,"name":"","group":2, "radius": 2.4, "x": 641.8, "y": 473.3, "icon":0},
            {"id": 95,"name":"","group":3, "radius": 10, "x": 895.8, "y": 345.4, "icon":0},
            {"id": 96,"name":"","group":3, "radius": 10, "x": 849.8, "y": 179.4, "icon":0},
            {"id": 97,"name":"","group":3, "radius": 10, "x": 705.8, "y": 201.4, "icon":0},
            {"id": 98,"name":"","group":3, "radius": 6.5, "x": 793.3, "y": 534.9, "icon":0},
            {"id": 99,"name":"","group":3, "radius": 6.5, "x": 912.3, "y": 291.9, "icon":0},
            {"id": 100,"name":"","group":3, "radius": 6.5, "x": 872.3, "y": 211.9, "icon":0},
            {"id": 101,"name":"","group":3, "radius": 6.5, "x": 669.3, "y": 199.9, "icon":0},
            {"id": 102,"name":"","group":3, "radius": 2.4, "x": 707.6, "y": 157.2, "icon":0},
            {"id": 103,"name":"","group":3, "radius": 1.5, "x": 668.6, "y": 157.2, "icon":0},
            {"id": 104,"name":"","group":3, "radius": 1.5, "x": 727.6, "y": 222.2, "icon":0},
            {"id": 105,"name":"","group":3, "radius": 1.5, "x": 808.6, "y": 182.2, "icon":0},
            {"id": 106,"name":"","group":3, "radius": 1.5, "x": 868.6, "y": 273.2, "icon":0},
            {"id": 107,"name":"","group":3, "radius": 1.5, "x": 758.6, "y": 284.2, "icon":0},
            {"id": 108,"name":"","group":3, "radius": 1.5, "x": 758.6, "y": 485.2, "icon":0},
            {"id": 109,"name":"","group":3, "radius": 1.5, "x": 728.6, "y": 536.2, "icon":0},
            {"id": 110,"name":"","group":3, "radius": 1.5, "x": 870.6, "y": 475.2, "icon":0},
            {"id": 111,"name":"","group":3, "radius": 1.5, "x": 840.6, "y": 392.2, "icon":0},
            {"id": 112,"name":"","group":3, "radius": 1.5, "x": 638.6, "y": 295.2, "icon":0},
            {"id": 113,"name":"","group":3, "radius": 1.5, "x": 888.6, "y": 184.2, "icon":0},
            {"id": 114,"name":"","group":3, "radius": 2.4, "x": 641.6, "y": 178.2, "icon":0},
            {"id": 115,"name":"","group":3, "radius": 2.4, "x": 591.6, "y": 163.2, "icon":0},
            {"id": 116,"name":"","group":3, "radius": 2.4, "x": 540.6, "y": 213.2, "icon":0},
            {"id": 117,"name":"","group":3, "radius": 2.4, "x": 659.6, "y": 97.2, "icon":0},
            {"id": 118,"name":"","group":3, "radius": 2.4, "x": 777.6, "y": 498.2, "icon":0},
            {"id": 119,"name":"","group":3, "radius": 2.4, "x": 686.6, "y": 492.2, "icon":0},
            {"id": 120,"name":"","group":3, "radius": 2.4, "x": 787.6, "y": 569.2, "icon":0},
            {"id": 121,"name":"","group":3, "radius": 2.4, "x": 901.6, "y": 436.2, "icon":0},
            {"id": 122,"name":"","group":4, "radius": 6.5, "x": 988.7, "y": 245.9, "icon":0},
            {"id": 123,"name":"","group":4, "radius": 6.5, "x": 1069.7, "y": 176.9, "icon":0},
            {"id": 124,"name":"","group":4, "radius": 6.5, "x": 1210.7, "y": 395.9, "icon":0},
            {"id": 125,"name":"","group":4, "radius": 6.5, "x": 1010.7, "y": 476.9, "icon":0},
            {"id": 126,"name":"","group":4, "radius": 6.5, "x": 1023.7, "y": 555.9, "icon":0},
            {"id": 127,"name":"","group":4, "radius": 6.5, "x": 1145.7, "y": 475.9, "icon":0},
            {"id": 128,"name":"","group":4, "radius": 6.5, "x": 1045.7, "y": 207.9, "icon":0},
            {"id": 129,"name":"","group":4, "radius": 2.4, "x": 1001.4, "y": 289.4, "icon":0},
            {"id": 130,"name":"","group":4, "radius": 1.5, "x": 941.4, "y": 416.6, "icon":0},
            {"id": 131,"name":"","group":4, "radius": 1.5, "x": 991.4, "y": 578.6, "icon":0},
            {"id": 132,"name":"","group":4, "radius": 1.5, "x": 1102.4, "y": 478.6, "icon":0},
            {"id": 133,"name":"","group":4, "radius": 1.5, "x": 1142.4, "y": 559.6, "icon":0},
            {"id": 134,"name":"","group":4, "radius": 1.5, "x": 1231.4, "y": 428.6, "icon":0},
            {"id": 135,"name":"","group":4, "radius": 1.5, "x": 1211.4, "y": 367.6, "icon":0},
            {"id": 136,"name":"","group":4, "radius": 1.5, "x": 1060.4, "y": 238.6, "icon":0},
            {"id": 137,"name":"","group":4, "radius": 1.5, "x": 1040.4, "y": 167.6, "icon":0},
            {"id": 138,"name":"","group":4, "radius": 1.5, "x": 1161.4, "y": 185.6, "icon":0},
            {"id": 139,"name":"","group":4, "radius": 1.5, "x": 1000.4, "y": 225.6, "icon":0},
            {"id": 140,"name":"","group":4, "radius": 1.5, "x": 982.4, "y": 309.6, "icon":0},
            {"id": 141,"name":"","group":4, "radius": 2.4, "x": 1045.7, "y": 234.7, "icon":0},
            {"id": 142,"name":"","group":4, "radius": 2.4, "x": 1148.7, "y": 156.7, "icon":0},
            {"id": 143,"name":"","group":4, "radius": 2.4, "x": 1196.7, "y": 504.7, "icon":0},
            {"id": 144,"name":"","group":4, "radius": 2.4, "x": 1267.7, "y": 406.7, "icon":0},
            {"id": 145,"name":"","group":4, "radius": 2.4, "x": 1237.7, "y": 367.7, "icon":0},
            {"id": 146,"name":"","group":4, "radius": 2.4, "x": 1237.7, "y": 326.7, "icon":0},
            {"id": 147,"name":"","group":4, "radius": 2.4, "x": 1086.7, "y": 549.7, "icon":0},
            {"id": 148,"name":"","group":4, "radius": 2.4, "x": 963.7, "y": 154.7, "icon":0},
            {"id": 149,"name":"","group":4, "radius": 2.4, "x": 913.7, "y": 545.7, "icon":0},
            {"id": 150,"name":"","group":4, "radius": 2.4, "x": 990.7, "y": 634.7, "icon":0},
            {"id": 151,"name":"","group":4, "radius": 2.4, "x": 866.7, "y": 539.7, "icon":0}
        ],
        "links": [
            {source: 0, target: 17,"group":0},
            {source: 0, target: 19,"group":0},
            {source: 0, target: 18,"group":0},
            {source: 18, target: 26,"group":0},
            {source: 18, target: 25,"group":0},
            {source: 26, target: 23,"group":0},
            {source: 0, target: 24,"group":0},
            {source: 23, target: 17,"group":0},
            {source: 17, target: 27,"group":0},
            {source: 17, target: 22,"group":0},
            {source: 27, target: 28,"group":0},
            {source: 22, target: 28,"group":0},
            {source: 22, target: 29,"group":0},
            {source: 28, target: 30,"group":0},
            {source: 30, target: 31,"group":0},
            {source: 23, target: 38,"group":0},
            {source: 27, target: 38,"group":0},
            {source: 39, target: 18,"group":0},
            {source: 39, target: 25,"group":0},
            {source: 25, target: 19,"group":0},
            {source: 19, target: 41,"group":0},
            {source: 24, target: 19,"group":0},
            {source: 40, target: 41,"group":0},
            {source: 40, target: 24,"group":0},
            {source: 27, target: 22,"group":0},
            {source: 41, target: 24,"group":0},
            {source: 42, target: 18,"group":0},
            {source: 42, target: 23,"group":0},
            {source: 42, target: 17,"group":0},
            {source: 43, target: 46,"group":1},
            {source: 43, target: 21,"group":1},
            {source: 51, target: 46,"group":1},
            {source: 46, target: 21,"group":1},
            {source: 46, target: 49,"group":1},
            {source: 49, target: 21,"group":1},
            {source: 49, target: 45,"group":1},
            {source: 50, target: 45,"group":1},
            {source: 45, target: 21,"group":1},
            {source: 45, target: 20,"group":1},
            {source: 21, target: 1,"group":1},
            {source: 21, target: 62,"group":1},
            {source: 62, target: 1,"group":1},
            {source: 20, target: 1,"group":1},
            {source: 20, target: 44,"group":1},
            {source: 20, target: 48,"group":1},
            {source: 44, target: 52,"group":1},
            {source: 44, target: 48,"group":1},
            {source: 44, target: 47,"group":1},
            {source: 48, target: 1,"group":1},
            {source: 48, target: 47,"group":1},
            {source: 47, target: 1,"group":1},
            {source: 47, target: 52,"group":1},
            {source: 65, target: 2,"group":2},
            {source: 72, target: 2,"group":2},
            {source: 72, target: 7,"group":2},
            {source: 72, target: 87,"group":2},
            {source: 72, target: 88,"group":2},
            {source: 88, target: 68,"group":2},
            {source: 88, target: 87,"group":2},
            {source: 87, target: 7,"group":2},
            {source: 87, target: 68,"group":2},
            {source: 68, target: 90,"group":2},
            {source: 68, target: 89,"group":2},
            {source: 68, target: 91,"group":2},
            {source: 89, target: 91,"group":2},
            {source: 89, target: 94,"group":2},
            {source: 94, target: 91,"group":2},
            {source: 91, target: 7,"group":2},
            {source: 7, target: 2,"group":2},
            {source: 2, target: 63,"group":2},
            {source: 2, target: 5,"group":2},
            {source: 5, target: 71,"group":2},
            {source: 5, target: 67,"group":2},
            {source: 71, target: 67,"group":2},
            {source: 71, target: 70,"group":2},
            {source: 70, target: 67,"group":2},
            {source: 70, target: 69,"group":2},
            {source: 70, target: 6,"group":2},
            {source: 70, target: 66,"group":2},
            {source: 70, target: 73,"group":2},
            {source: 66, target: 73,"group":2},
            {source: 73, target: 6,"group":2},
            {source: 69, target: 6,"group":2},
            {source: 69, target: 74,"group":2},
            {source: 66, target: 92,"group":2},
            {source: 92, target: 93,"group":2},
            {source: 92, target: 6,"group":2},
            {source: 64, target: 7,"group":2},
            {source: 64, target: 91,"group":2},
            {source: 64, target: 63,"group":2},
            {source: 76, target: 5,"group":2},
            {source: 76, target: 62,"group":2},
            {source: 62, target: 5,"group":2},
            {source: 75, target: 5,"group":2},
            {source: 75, target: 65,"group":2},
            {source: 75, target: 2,"group":2},
            {source: 115, target: 116,"group":3},
            {source: 115, target: 114,"group":3},
            {source: 115, target: 8,"group":3},
            {source: 116, target: 8,"group":3},
            {source: 114, target: 117,"group":3},
            {source: 114, target: 101,"group":3},
            {source: 101, target: 102,"group":3},
            {source: 101, target: 97,"group":3},
            {source: 101, target: 8,"group":3},
            {source: 102, target: 97,"group":3},
            {source: 97, target: 9,"group":3},
            {source: 97, target: 8,"group":3},
            {source: 8, target: 9,"group":3},
            {source: 8, target: 3,"group":3},
            {source: 9, target: 3,"group":3},
            {source: 9, target: 10,"group":3},
            {source: 10, target: 96,"group":3},
            {source: 10, target: 100,"group":3},
            {source: 10, target: 3,"group":3},
            {source: 10, target: 11,"group":3},
            {source: 96, target: 100,"group":3},
            {source: 11, target: 3,"group":3},
            {source: 11, target: 99,"group":3},
            {source: 11, target: 95,"group":3},
            {source: 11, target: 121,"group":3},
            {source: 11, target: 12,"group":3},
            {source: 99, target: 95,"group":3},
            {source: 95, target: 121,"group":3},
            {source: 12, target: 3,"group":3},
            {source: 121, target: 12,"group":3},
            {source: 121, target: 118,"group":3},
            {source: 121, target: 98,"group":3},
            {source: 98, target: 120,"group":3},
            {source: 118, target: 98,"group":3},
            {source: 118, target: 12,"group":3},
            {source: 119, target: 118,"group":3},
            {source: 119, target: 98,"group":3},
            {source: 151, target: 149,"group":4},
            {source: 149, target: 126,"group":4},
            {source: 149, target: 125,"group":4},
            {source: 126, target: 150,"group":4},
            {source: 126, target: 147,"group":4},
            {source: 126, target: 125,"group":4},
            {source: 126, target: 15,"group":4},
            {source: 125, target: 15,"group":4},
            {source: 15, target: 4,"group":4},
            {source: 15, target: 147,"group":4},
            {source: 147, target: 127,"group":4},
            {source: 147, target: 143,"group":4},
            {source: 127, target: 143,"group":4},
            {source: 127, target: 16,"group":4},
            {source: 143, target: 16,"group":4},
            {source: 16, target: 4,"group":4},
            {source: 16, target: 124,"group":4},
            {source: 16, target: 144,"group":4},
            {source: 124, target: 144,"group":4},
            {source: 124, target: 145,"group":4},
            {source: 144, target: 145,"group":4},
            {source: 124, target: 14,"group":4},
            {source: 145, target: 14,"group":4},
            {source: 146, target: 14,"group":4},
            {source: 4, target: 14,"group":4},
            {source: 14, target: 142,"group":4},
            {source: 14, target: 13,"group":4},
            {source: 13, target: 4,"group":4},
            {source: 13, target: 142,"group":4},
            {source: 13, target: 123,"group":4},
            {source: 13, target: 128,"group":4},
            {source: 123, target: 142,"group":4},
            {source: 123, target: 128,"group":4},
            {source: 4, target: 141,"group":4},
            {source: 4, target: 129,"group":4},
            {source: 122, target: 129,"group":4},
            {source: 122, target: 141,"group":4},
            {source: 122, target: 148,"group":4},
            {source: 129, target: 141,"group":4},
            {source: 0, target: 43,"group":0},
            {source: 0, target: 21,"group":1},
            {source: 0, target: 62,"group":0},
            {source: 0, target: 76,"group":2},
            {source: 78, target: 22,"group":0},
            {source: 78, target: 30,"group":0},
            {source: 78, target: 67,"group":2},
            {source: 78, target: 115,"group":3},
            {source: 1, target: 65,"group":1},
            {source: 1, target: 2,"group":2},
            {source: 3, target: 6,"group":3},
            {source: 3, target: 63,"group":2},
            {source: 3, target: 64,"group":3},
            {source: 52, target: 88,"group":1},
            {source: 94, target: 119,"group":3},
            {source: 4, target: 99,"group":4},
            {source: 4, target: 95,"group":3},
            {source: 121, target: 125,"group":4}
        ]
    };

    const links = data.links.map(d => Object.create(d));
    const nodes = data.nodes.map(d => Object.create(d));

    const assetPath = '/_assets/cb52561705753b7640fdeb0739dcb280/';

    const iconArray = [
        "",
        assetPath + "Images/HtmlElement/agencyAnimation/Smartphone.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/Watch.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/Car.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/facebook.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/youtube.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/Warenkorb.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/shop.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/tanteemmaladen.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/flugzeug.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/health.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/shirt.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/fabrik.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/connect.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/zahnraeder.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/lupe.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/herzschlag.svg",
        assetPath + "Images/HtmlElement/agencyAnimation/people_mit_pfeil.svg"
    ];

    const colorArray = [
        "#C50968",
        "#575756",
        "#96C120",
        "#0896D5",
        "#115D82"
    ];

    function name(d) { return d.name; }
    function group(d) { return d.group; }
    function icons(d) { return d.icon; }

    function colorByGroup(d) { return colorArray[group(d)]; }
    function iconByName(d) { return iconArray[icons(d)]; }

    d3.forceSimulation(nodes)
        .force("link", d3.forceLink(links).id(d => d.id));

    const svg = d3.select("#graph")
        .attr("viewBox", [0, 0, width, height]);

    const link = svg.selectAll(".link")
        .data(links)
        .join("line")
        .attr("x1", function(d) { return d.source.x; })
        .attr("y1", function(d) { return d.source.y; })
        .attr("x2", function(d) { return d.target.x; })
        .attr("y2", function(d) { return d.target.y; })
        .attr("stroke", colorByGroup)
        .attr("class", "link");

    const node = svg.selectAll(".node")
        .data(nodes)
        .join("g")
        .attr("class", "node")
        .attr("transform", function(d) { return "translate(" + d.x + "," + d.y + ")"; });

    node.append("circle")
        .attr("r", function(d) {return d.radius;})
        .attr('fill', colorByGroup);

    node.append("text")
        .attr("dy", ".35em")
        .text(function(d) { return name(d); });

    node.append("image")
        .attr("xlink:href", iconByName)
        .attr("x", "-50")
        .attr("y", "-50")
        .attr("height", "100px")
        .attr("width", "100px");

    node.transition()
        .call(steps).call(steps2);

    function steps() {
        node.filter(function (d, i) { return i < 5; }).transition()
            .duration(750)
            .style("opacity", 1);
    }

    function steps2() {
        node.filter(function (d, i) { return i >= 5; }).transition()
            .delay(1000)
            .duration(950)
            .style("opacity", 1);
    }

    link.transition()
        .call(steps3).call(steps4).call(steps5).call(steps6).call(steps7).call(steps8);

    function steps3() {
        link.filter(function (d, i) { return i > 0 && i <= 28; }).transition()
            .delay(2000)
            .duration(750)
            .style("opacity", 1);
    }

    function steps4() {
        link.filter(function (d, i) { return i >= 29 && i <= 51; }).transition()
            .delay(2500)
            .duration(750)
            .style("opacity", 1);
    }

    function steps5() {
        link.filter(function (d, i) { return i >= 52 && i <= 95; }).transition()
            .delay(3000)
            .duration(750)
            .style("opacity", 1);
    }

    function steps6() {
        link.filter(function (d, i) { return i >= 96 && i <= 132; }).transition()
            .delay(3500)
            .duration(750)
            .style("opacity", 1);
    }

    function steps7() {
        link.filter(function (d, i) { return i >= 133 && i <= 171; }).transition()
            .delay(4000)
            .duration(750)
            .style("opacity", 1);
    }

    function steps8() {
        link.filter(function (d, i) { return i >= 172; }).transition()
            .delay(4500)
            .duration(750)
            .style("opacity", 1);
    }

})();
